import React from 'react';
import './DocumentationButton.css';

interface DocumentationButtonProps {
  onClick: () => void;
}

const DocumentationButton: React.FC<DocumentationButtonProps> = ({ onClick }) => {
  const loginCount = parseInt(sessionStorage.getItem('login_count') || '0', 10);
  const label = loginCount >= 5 ? 'Help' : 'How to Start';

  return (
    <button
      className="documentation-button"
      onClick={onClick}
      title={loginCount >= 5 ? 'View Documentation & Prompts' : 'Learn how to get started with Cubemate'}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10"/>
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
        <line x1="12" y1="17" x2="12.01" y2="17"/>
      </svg>
      <span className="documentation-button-text">{label}</span>
    </button>
  );
};

export default DocumentationButton;
